package it.neckar.lizergy.model.project.process.state

import it.neckar.lizergy.lifeCycle.LizergyLifeCycleState
import it.neckar.lizergy.model.company.CompanyCode
import it.neckar.lizergy.model.project.process.state.BlueprintProcessStateEntry.BlueprintProcessStates.BeingEdited
import it.neckar.lizergy.model.project.process.state.BlueprintProcessStateEntry.BlueprintProcessStates.Done
import it.neckar.open.i18n.I18nConfiguration
import it.neckar.open.kotlin.serializers.IsoMillis
import it.neckar.processStates.ProcessStateEntryId
import it.neckar.processStates.ProcessStatePhase
import it.neckar.user.UserLoginName
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
@SerialName("BlueprintProcessStateEntry")
data class BlueprintProcessStateEntry(
  override val id: ProcessStateEntryId,
  override val processState: BlueprintProcessStates,
  override val assignedTo: UserLoginName,
  override val belongsTo: CompanyCode,
  override val assignedAt: IsoMillis,
  override val assignedBy: UserLoginName,
  override val lifeCycleState: LizergyLifeCycleState = LizergyLifeCycleState.Active,
) : LizergyProcessStateEntry {

  override val availableOptions: List<BlueprintProcessStates>
    get() = BlueprintProcessStates.entries

  override fun format(i18nConfiguration: I18nConfiguration): String {
    return when (processState) {
      BeingEdited, Done -> processState.format(i18nConfiguration)
    }
  }

  @Serializable
  @SerialName("BlueprintProcessStates")
  enum class BlueprintProcessStates : LizergyProcessStates {
    BeingEdited,
    Done,

    ;

    override val inPhase: ProcessStatePhase
      get() = when (this) {
        BeingEdited -> ProcessStatePhase.InProgress
        Done -> ProcessStatePhase.Done
      }

    override fun format(i18nConfiguration: I18nConfiguration): String {
      return when (this) {
        BeingEdited -> "PE in Bearbeitung"
        Done -> "PE vollendet"
      }
    }
  }
}
